import React, { useState, useEffect, useRef, useCallback } from "react";
import live_icon from "../assets/live_Icon.png";
// import { fetchContent } from "../services/api";
import $ from "jquery";
import LiveEvents from "./LiveEvents";
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import Wrapper from "./shared/Wrapper";
import liveDot from "../assets/liveDot.png";
import { getLiveSection } from "../services/services";
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";

const RowList = ({
  borderRadius,
  rowWidth,
  rowHeight,
  columnWidth,
  columnHeight,
  itemWidth,
  itemHeight,
  animationSpeed,
  bgColor,
  shouldFocus,
  marginLeft,
  marginTop,
  borderColor,
  fontSize,
  fontColor,
  selectionStyle,
  data,
  border,
  FocusHandler,
  RowlListcallBack,
  handleBackButton,
  handleRowListDownButton,
  handleRowListUpButton,
  shouldUpFocus,
  isOnfocusDataLoad = false,
  gapBetweenColumn = 0,
  activeStyle,
  lastFocusedElementRowList,
  rememberFocusItem,
  rememberFocusItem1,
  lastRememberFocusedRowList,
  screen,
  page
  // setActiveItem
}) => {
  console.log("lastFocusedElementRowList....", lastFocusedElementRowList, "shouldFocus", rememberFocusItem, lastRememberFocusedRowList);
  let selectedRow = lastFocusedElementRowList === "RowList" ? rememberFocusItem : lastRememberFocusedRowList === "TV" ? 0 : lastRememberFocusedRowList === "Radio" ? 1 : 0;
  const [selectedIndex, setSelectedIndex] = useState(rememberFocusItem || 0);
  const [activeItem, setActiveItem] = useState(rememberFocusItem || 0);
  const rowRef = useRef(null);

  const [state, setState] = useState({
    liveEventsData: null,
    OnfocusDataLoad: isOnfocusDataLoad,
  });
  const { liveEventsData, OnfocusDataLoad } = state;

  console.log("selectionStyle", selectionStyle);

  function debounceMultiple(funcs, delay) {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        funcs.forEach((fn) => fn(...args));
      }, delay);
    };
  }

  // useEffect(() => {
  //   // console.log("shouldFocus....", shouldFocus);
  //   if (shouldFocus) {
  //     let tmr = setTimeout(function () {
  //       clearTimeout(tmr);
  //       rowRef?.current.focus();
  //     }, 200);
  //   }
  // }, [shouldFocus, OnfocusDataLoad]);

  const scrollToItem = (index) => {
    const $row = $("#grid-row");
    const containerWidth = $row.width();
    const itemWidth = $row.children().first().outerWidth(true); // Calculate actual item width
    const visibleItems = Math.floor(containerWidth / itemWidth);
    const currentScroll = $row.scrollLeft();
    const targetPos = index * itemWidth;

    // Only scroll if item is not fully visible
    if (targetPos < currentScroll || targetPos > currentScroll + containerWidth - itemWidth) {
      $row.stop().animate(
        { scrollLeft: targetPos - (containerWidth / 2) + (itemWidth / 2) }, // Center the item
        300,
        () => {
          console.log(`Scrolled to index ${index} at position ${targetPos}`);
        }
      );
    }
  };

  useEffect(() => {
    if (rememberFocusItem !== undefined && rememberFocusItem !== null) {
      console.log("Restoring scroll position for:", rememberFocusItem);

      // Wait for DOM to update then scroll to position
      setTimeout(() => {
        scrollToItem(rememberFocusItem);
        setSelectedIndex(rememberFocusItem);
        setActiveItem(rememberFocusItem);
        scrollLeft1(rememberFocusItem);
      }, 50); // Small timeout ensures DOM is ready
    }
  }, [rememberFocusItem]);

  const scrollLeft1 = (selectedIndex) => {
    const $row = $("#grid-row");
    const containerWidth = $row.width();
    const itemWidth = $row.children().first().outerWidth(true);
    const visibleItems = Math.floor(containerWidth / itemWidth);

    // Calculate target position to center the item
    const targetPos = selectedIndex * itemWidth - (containerWidth / 4) + (itemWidth / 4);
    console.log("targetPos", targetPos, "selectedIndex", selectedIndex, "itemWidth", itemWidth, "containerWidth", containerWidth);

    $row.stop().animate(
      { scrollLeft: targetPos },
      300,
      () => {
        console.log(`Scrolled to show item ${selectedIndex} at position ${targetPos}`);
      }
    );
  };

  const handleKeyDown = (e) => {
    // console.log("selectedIndex...rowlist....", selectedIndex);
    const rowLength = data.length;
    // console.log("rowLength...", rowLength);
    if (e.keyCode == 39) {
      if (selectedIndex < rowLength - 1) {
       
        setSelectedIndex(selectedIndex + 1);
        scrollLeft(selectedIndex);
        // scrollLeft();
      }
    } else if (e.keyCode == 37) {
      // console.log("left key...", selectedIndex,e.keyCode);
      if (selectedIndex > 0) {
        setSelectedIndex(selectedIndex - 1);
        scrollRight(selectedIndex);
        // scrollRight();
      } else {
        console.log("back button pressed....", handleBackButton);
        handleBackButton();
        window.removeEventListener("keyDown", handleKeyDown);
        rowRef.current.removeEventListener("keyDown", handleKeyDown);
        rowRef.current.blur();
      }
    } else if (e.keyCode == 13) {
      console.log(
        "enter on rowList button....",
        data[selectedIndex],
        selectedIndex,
        "screen:",
        screen
      );
      console.log(
        "RowlListcallBack(data[selectedIndex], selectedIndex)",
        RowlListcallBack(data[selectedIndex], selectedIndex),
        activeItem,
        data[selectedIndex].id
      );
      if (data[selectedIndex]?.isLive == 1) {
        console.log(
          "RowlListcallBack(data[selectedIndex], selectedIndex)",
          RowlListcallBack(data[selectedIndex], selectedIndex),
          activeItem,
          data[selectedIndex]?.id
        );
        setActiveItem(selectedIndex);
        // RowlListcallBack(data[selectedIndex], selectedIndex);
        rowRef.current.removeEventListener("keydown", handleKeyDown);
        loadData();
      } else {
        console.log(
          "RowlListcallBack(data[selectedIndex], selectedIndex)",
          RowlListcallBack(data[selectedIndex], selectedIndex),
          activeItem,
          data[selectedIndex].id
        );
        setActiveItem(selectedIndex);
        RowlListcallBack(data[selectedIndex], selectedIndex);

        if (page === "home") {
          sendTestMatomoEvent({
            eventCategory: "TagMenu",
            eventAction: "Select",
            eventName :`Tag(${data[selectedIndex].id}/${data[selectedIndex].title})`,
            url: page,
          });
          sendTestMatomoEvent({
            eventCategory: "HomePage",
            eventAction: "Select",
            eventName :`Tag(${data[selectedIndex].id}/${data[selectedIndex].title})`,
            url: page,
          });
        } else if (page == "tv-radio") {
          sendTestMatomoEvent({
            eventCategory: "Live",
            eventAction: "Select",
            eventName :`Live - Select - ${
              data[selectedIndex].title === "TV"
                ? "LiveChannel"
                : `Live${data[selectedIndex].title}`
              }`,
            url: page,
          });
        }
      }
    } else if (e.keyCode === 8 || e.keyCode === 10009 || e.keyCode == 461) {
      console.log("back button pressed....", handleBackButton);
      window.removeEventListener("keyDown", handleKeyDown);
      rowRef.current.removeEventListener("keyDown", handleKeyDown);
      rowRef.current.blur();
      handleBackButton();
    } else if (e.keyCode == 40) {                       
      // Prevent moving focus down for certain static pages
      const currentId = data[selectedIndex]?.id;
      const excluded = [
        "aboutus",
        "privacypolicy",
        "termsandcondition",
        "helpandsupport",
        "subscriptionrental",
        "myaccount",
        "referalcode",
      ];
 
      if (!excluded.includes(currentId)) {
        // Special-case for AppLanguage: only allow down navigation when the
        // AppLanguage row has been selected/activated (user pressed Enter).
        if (currentId === "applanguage") {
          if (activeItem === selectedIndex) {
            rowRef.current.removeEventListener("keyDown", handleKeyDown);
            rowRef.current.blur();
            handleRowListDownButton();
          } else {
            // Do nothing: ignore down key so focus won't disappear
          }
        } else {
          rowRef.current.removeEventListener("keyDown", handleKeyDown);
          rowRef.current.blur();
          handleRowListDownButton();
        }
      }
    
      // rowRef.current.removeEventListener('keyDown', handleKeyDown);
      // rowRef.current.blur();
      // handleRowListDownButton();
    } else if (e.keyCode == 38) {
      // up arrow
      handleRowListUpButton
        ? handleRowListUpButton()
        // : console.log("Up will not work.");
        : handleBackButton();console.log("Up will not work.");
    }
  };
  const loadData = async () => {
    console.log("getLiveEvents Data.......");
    const user_details = JSON.parse(localStorage.getItem("user_details"));
    const userId = localStorage.getItem("profileId");
    const getCountry = localStorage.getItem("country");

    let myHeaders = {
      // is_home_page: "1",
      platform: "0",
      iskid: "0",
      isDefault: "0",
      country: getCountry,
      ageGroup: "12",
      // Langid: "1",
      // 
      // profileid: userId,
      Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
      "Content-Type": "application/json",
    };
    try {
      // const [getLiveEvents] = await Promise.all([
      //   fetchContent(
      //     `/V1/getLiveSection/0/0/0/India/1`,
      //     "GET",
      //     myHeaders
      //   ).catch((error) => null),
      // ]);
      const getLiveEvents = await getLiveSection(getCountry)
      FocusHandler("LiveEvent", getLiveEvents.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // const scrollLeft = () => {
  //   $("#grid-row").animate(
  //     {
  //       scrollLeft: `+=${itemWidth}`,
  //     },
  //     100,
  //     RowlListcallBack(data[selectedIndex + 1], selectedIndex + 1)
  //   );
  // };

  const scrollLeft = (selectedIndex) => {
    const maxVisibleItems = 3; // Number of visible items before scrolling
    // const itemWidth = $("#grid-row").children().first().outerWidth(true); // Width of a single item

    // console.log("scrollLeft....", itemWidth, "selectedIndex:", selectedIndex);

    // Check if selectedIndex is 7 or greater
    if (selectedIndex >= maxVisibleItems) {
      $("#grid-row").animate(
        {
          scrollLeft: `+=${itemWidth}`, // Increment scroll position
        },
        100,
        () => {
          console.log("Scrolled to the left");
        }
      );
    } else {
      console.log("No scroll needed for selectedIndex:", selectedIndex);
    }
  };

  // const scrollRight = () => {
  //   $("#grid-row").animate(
  //     {
  //       scrollLeft: `-=${itemWidth}`,
  //     },
  //     100,
  //     RowlListcallBack(data[selectedIndex - 1], selectedIndex - 1)
  //   );
  // };



  const scrollRight = (selectedIndex) => {
    const maxVisibleItems = data.length - 3; // Number of visible items in the viewport
    const totalItems = $("#grid-row").children().length; // Total number of items in the row

    // console.log("scrollRight....", itemWidth, "selectedIndex:", selectedIndex);

    // Check if scrolling is needed (if there are more items to the right)
    if (selectedIndex < maxVisibleItems) {
      $("#grid-row").animate(
        {
          scrollLeft: `-=${itemWidth}`, // Increment scroll position to move to the right
        },
        100,
        // RowlListcallBack(data[selectedIndex - 1], selectedIndex - 1)
        () => {
          console.log("Scrolled to the right");
        }
      );
    } else {
      console.log("No scroll needed for selectedIndex:", selectedIndex);
    }
  };

  {
    console.log(activeItem, "itemIndex");
  }

  useEffect(() => {
    // console.log("shouldFocus....", shouldFocus);
    if (shouldFocus) {
      let tmr = setTimeout(function () {
        clearTimeout(tmr);
        rowRef?.current?.focus();
      }, 200);
    }
  }, [shouldFocus, OnfocusDataLoad]);

  useEffect(() => {
    if (screen === "LiveScreen") {
      if (lastRememberFocusedRowList === "Radio") {
        setSelectedIndex(1);
        setActiveItem(1);
      } else {
        setSelectedIndex(0);
        setActiveItem(0);
      }
    }
  }, [lastRememberFocusedRowList, screen]);

  // const scrollLeft = () => {
  //   $("#grid-row").animate(
  //     {
  //       scrollLeft: `+=${itemWidth}`,
  //     },
  //     100,
  //     // RowlListcallBack(data[selectedIndex + 1], selectedIndex + 1)
  //   );
  // };

  // const scrollRight = () => {
  //   $("#grid-row").animate(
  //     {
  //       scrollLeft: `-=${itemWidth}`,
  //     },
  //     100,
  //     // RowlListcallBack(data[selectedIndex - 1], selectedIndex - 1)
  //   );
  // };

  // const scrollLeft = () => {
  //   $('#grid-row').animate({
  //     scrollLeft: `+=${itemWidth}`
  //   }, animationSpeed, RowlListcallBack(data[selectedIndex + 1], (selectedIndex + 1)));
  // };

  // const scrollRight = () => {
  //   $('#grid-row').animate({
  //     scrollLeft: `-=${itemWidth}`
  //   }, animationSpeed, RowlListcallBack(data[selectedIndex - 1], (selectedIndex - 1)));
  // };

  const debouncedKeyDown = useCallback(
    debounceMultiple([handleKeyDown], 10),
    [handleKeyDown]
  );


  return (
    <div
      ref={rowRef}
      style={{
        width: rowWidth,
        height: rowHeight,
        backgroundColor: bgColor,
        marginLeft: marginLeft,
        marginTop: marginTop,
        overflow: "hidden",
        whiteSpace: "nowrap",
        outline: "none",
        display: "flex",
        alignItems: "center",
        // outline: "none",
        // backgroundColor:"#0E1653",
        // background: `url(${solidbackgroundimg})`,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
      }}
      tabIndex="0"
      onKeyDown={debouncedKeyDown}
      id="grid-row"
    >
      {data.map((item, index) => (
        <div
          key={item.id}
          style={{
            // width: columnWidth,
            // height: columnHeight,
            // display: "flex",
            // justifyContent: "center",
            alignItems: "center",
            marginRight: gapBetweenColumn + "px",
          }}
        >
          <Wrapper
            style={{
              // display: "flex",
              flexDirection: "column",
              width: "fit-content",
              padding: "10px 60px",
              // padding: "15px 60px",
              // height: itemHeight,
              lineHeight: `${itemHeight}px`,
              textAlign: "center",
              justifyContent: "center",
              // backgroundColor:"#0E1653",
              backgroundColor:
                selectionStyle === "background" &&
                  selectedIndex === index &&
                shouldFocus
                  ? borderColor
                    : "transparent",
                  // activeItem === index
                  // ? "transparent"
                  // : "transparent",

              border:
                activeStyle === "border" && activeItem === index
                  ? "3px solid #fff"
                  : "none",
              position: "relative",
              boxSizing: "border-box",
              cursor: "pointer",
              borderRadius:
                selectedIndex === index ? borderRadius : borderRadius,
              fontSize: fontSize,
              color: fontColor,
              marginLeft: "10px",
            }}
            onMouseEnter={() => {
                setSelectedIndex(index);
            }}
            onClick={() => {
              if (item.isLive == 1) {
                setActiveItem(index);
                loadData();
              } else {
                console.log("rowList.....");
                console.log(item.id, "itemIndex");
                setActiveItem(index);
                setSelectedIndex(index);
                RowlListcallBack(item, index);
              }
            }}
          >
            {item.title === "Live" && (
              <img
                src={liveDot}
                style={{ width: "12px", height: "12px", marginRight: "5px", verticalAlign: "middle" }}
              />
              // <span style={{ fontSize: "16px", marginRight: "5px" }}>🔴</span>
            )}
            {item.title}

            {index === activeItem && activeStyle === "underline" && !(shouldFocus && selectedIndex === index) && (
                <span
                  style={{
                    content: "''",
                    position: "absolute",
                    bottom: "-10px",
                    left: "50%",
                    width: "50%", // Adjust width of the underline
                    height: "8px", // Thickness of underline
                    backgroundColor: "#EC008C", // Color of underline
                    transform: "translateX(-50%)", // Centering the underline
                  }}
                />
              )}
             {index === activeItem && activeItem !== selectedIndex && activeStyle==="underline" && screen === "SettingsScreen" &&(
                <span
                  style={{
                    content: "''",
                    position: "absolute",
                    bottom: "-10px",
                    left: "50%",
                    width: "50%", // Adjust width of the underline
                    height: "8px", // Thickness of underline
                    backgroundColor: "#EC008C", // Color of underline
                    transform: "translateX(-50%)", // Centering the underline
                  }}
                />
              )}
          </Wrapper>
        </div>
      ))}
    </div>
  );
};

export default RowList;